import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { AzureApiService } from "../../services/azure-api.service";
import {plainToClass} from "class-transformer";
import {DtoCustomerInfoBaseItems} from "./models/DtoCustomerInfoBaseItems";
import {DtoManagementCustomerFilter} from "./models/DtoManagementCustomerFilter";
import {DtoManagementCustomer} from "./models/DtoManagementCustomer";

@Injectable()
export class ManagementCustomerInfoService {
    private apiUrl: string;

    constructor(private http: AzureApiService) {
        this.apiUrl = 'management'
    }

    public getCustomerInfo = (filter: DtoManagementCustomerFilter): Observable<DtoManagementCustomer> => {
        return this.http.post<DtoManagementCustomer>(`${this.apiUrl}/customerinfo/`, filter);
    };

    public getCustomerInfoBaseItems = (): Observable<DtoCustomerInfoBaseItems> => {
        return this.http.get<DtoCustomerInfoBaseItems>(`${this.apiUrl}/customerinfo/baseitems`);
    };
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/management/customer-info/management-customer-info.service.ts